import type { AccountBalance } from "@/hooks/useAccounts";

type PeriodBalance = Pick<AccountBalance, "monthly_balance">;

/** The API resolves calendar months for debit/cash/savings and billing cycles for credit. */
export const getAccountCardBalance = (account: PeriodBalance): number => Number(account.monthly_balance ?? 0);

export const getAccountsPeriodTotals = (accounts: readonly PeriodBalance[]) => {
  const haveNow = accounts.reduce((sum, account) => sum + Math.max(getAccountCardBalance(account), 0), 0);
  const oweNow = accounts.reduce((sum, account) => sum + Math.max(-getAccountCardBalance(account), 0), 0);
  return { haveNow, oweNow, totalBalance: haveNow - oweNow };
};

/** Activity is independent of net balance and configured credit capacity. */
export const hasAccountActivity = (account: Pick<AccountBalance, "monthly_deposit" | "monthly_expense">): boolean =>
  Number(account.monthly_deposit ?? 0) !== 0 || Number(account.monthly_expense ?? 0) !== 0;
